export const SNIPPET_TYPES = {
  WAITLIST: "waitlist",
  RESERVATION: "reservation"
};

export const PREMIUM_TO_PRO = "PREMIUM_TO_PRO";
